/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetCurrentAdminUser200Response } from '../models';
// @ts-ignore
import { GetCurrentUser200Response } from '../models';
// @ts-ignore
import { PutCurrentUserRequest } from '../models';
/**
 * UserProfileApi - axios parameter creator
 * @export
 */
export const UserProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 管理者ユーザー情報取得API
         * @summary 管理者ユーザー情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAdminUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログインユーザー情報取得API
         * @summary ログインユーザー情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザーアバター画像更新API
         * @summary ユーザーアバター画像更新API
         * @param {any} image 画像ファイル（Blob)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCurrentUserAvatarImage: async (image: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'image' is not null or undefined
            assertParamExists('postCurrentUserAvatarImage', 'image', image)
            const localVarPath = `/api/user/update_avatar_image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザープロファイル更新API
         * @summary ユーザープロファイル更新API
         * @param {PutCurrentUserRequest} [putCurrentUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCurrentUser: async (putCurrentUserRequest?: PutCurrentUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/update_me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putCurrentUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserProfileApi - functional programming interface
 * @export
 */
export const UserProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 管理者ユーザー情報取得API
         * @summary 管理者ユーザー情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentAdminUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentAdminUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentAdminUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログインユーザー情報取得API
         * @summary ログインユーザー情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザーアバター画像更新API
         * @summary ユーザーアバター画像更新API
         * @param {any} image 画像ファイル（Blob)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCurrentUserAvatarImage(image: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCurrentUserAvatarImage(image, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザープロファイル更新API
         * @summary ユーザープロファイル更新API
         * @param {PutCurrentUserRequest} [putCurrentUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCurrentUser(putCurrentUserRequest?: PutCurrentUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCurrentUser(putCurrentUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserProfileApi - factory interface
 * @export
 */
export const UserProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserProfileApiFp(configuration)
    return {
        /**
         * 管理者ユーザー情報取得API
         * @summary 管理者ユーザー情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAdminUser(options?: any): AxiosPromise<GetCurrentAdminUser200Response> {
            return localVarFp.getCurrentAdminUser(options).then((request) => request(axios, basePath));
        },
        /**
         * ログインユーザー情報取得API
         * @summary ログインユーザー情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: any): AxiosPromise<GetCurrentUser200Response> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザーアバター画像更新API
         * @summary ユーザーアバター画像更新API
         * @param {any} image 画像ファイル（Blob)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCurrentUserAvatarImage(image: any, options?: any): AxiosPromise<void> {
            return localVarFp.postCurrentUserAvatarImage(image, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザープロファイル更新API
         * @summary ユーザープロファイル更新API
         * @param {PutCurrentUserRequest} [putCurrentUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCurrentUser(putCurrentUserRequest?: PutCurrentUserRequest, options?: any): AxiosPromise<void> {
            return localVarFp.putCurrentUser(putCurrentUserRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserProfileApi - interface
 * @export
 * @interface UserProfileApi
 */
export interface UserProfileApiInterface {
    /**
     * 管理者ユーザー情報取得API
     * @summary 管理者ユーザー情報取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApiInterface
     */
    getCurrentAdminUser(options?: AxiosRequestConfig): AxiosPromise<GetCurrentAdminUser200Response>;

    /**
     * ログインユーザー情報取得API
     * @summary ログインユーザー情報取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApiInterface
     */
    getCurrentUser(options?: AxiosRequestConfig): AxiosPromise<GetCurrentUser200Response>;

    /**
     * ユーザーアバター画像更新API
     * @summary ユーザーアバター画像更新API
     * @param {any} image 画像ファイル（Blob)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApiInterface
     */
    postCurrentUserAvatarImage(image: any, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * ユーザープロファイル更新API
     * @summary ユーザープロファイル更新API
     * @param {PutCurrentUserRequest} [putCurrentUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApiInterface
     */
    putCurrentUser(putCurrentUserRequest?: PutCurrentUserRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for postCurrentUserAvatarImage operation in UserProfileApi.
 * @export
 * @interface UserProfileApiPostCurrentUserAvatarImageRequest
 */
export interface UserProfileApiPostCurrentUserAvatarImageRequest {
    /**
     * 画像ファイル（Blob)
     * @type {any}
     * @memberof UserProfileApiPostCurrentUserAvatarImage
     */
    readonly image: any
}

/**
 * Request parameters for putCurrentUser operation in UserProfileApi.
 * @export
 * @interface UserProfileApiPutCurrentUserRequest
 */
export interface UserProfileApiPutCurrentUserRequest {
    /**
     * 
     * @type {PutCurrentUserRequest}
     * @memberof UserProfileApiPutCurrentUser
     */
    readonly putCurrentUserRequest?: PutCurrentUserRequest
}

/**
 * UserProfileApi - object-oriented interface
 * @export
 * @class UserProfileApi
 * @extends {BaseAPI}
 */
export class UserProfileApi extends BaseAPI implements UserProfileApiInterface {
    /**
     * 管理者ユーザー情報取得API
     * @summary 管理者ユーザー情報取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getCurrentAdminUser(options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getCurrentAdminUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログインユーザー情報取得API
     * @summary ログインユーザー情報取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public getCurrentUser(options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザーアバター画像更新API
     * @summary ユーザーアバター画像更新API
     * @param {UserProfileApiPostCurrentUserAvatarImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public postCurrentUserAvatarImage(requestParameters: UserProfileApiPostCurrentUserAvatarImageRequest, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).postCurrentUserAvatarImage(requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザープロファイル更新API
     * @summary ユーザープロファイル更新API
     * @param {UserProfileApiPutCurrentUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public putCurrentUser(requestParameters: UserProfileApiPutCurrentUserRequest = {}, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).putCurrentUser(requestParameters.putCurrentUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
